<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      <b-button class="button is-primary" @click="handleAddVolunteer">
        Adauga voluntar
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <card-component
        class="has-table has-mobile-sort-spaced"
        title="Voluntari"
        icon="account-multiple"
      >
        <volunteers-table
          :volunteers="volunteers"
          :isLoading="isLoading"
          :total="totalCount"
          :current-page="currentPage"
          @handleDeleteVolunteer="handleDeleteVolunteer"
          @page-change="onPageChange"
        ></volunteers-table>
      </card-component>
      <hr />
    </section>
  </div>
</template>

<script>
import Volunteering from "@/services/volunteering.service";
import { notify } from "@/helpers/notify";
const _ = require("lodash");
import CardComponent from "@/components/CardComponent";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import VolunteersTable from "@/components/volunteering/volunteers-table.vue";

export default {
  name: "Volunteering",
  components: {
    HeroBar,
    TitleBar,
    CardComponent,
    VolunteersTable,
  },
  data() {
    return {
      isLoading: true,
      volunteers: [],
      currentPage: 1,
      totalCount: 0,
      pageSize: 20,
    };
  },
  created() {
    this.loadVolunteers();
  },
  methods: {
    loadVolunteers() {
      this.isLoading = true;
      this.getAllVolunteers().finally(() => {
        this.isLoading = false;
      });
    },
    async getAllVolunteers() {
      const { getVolunteers } = Volunteering;
      const response = await getVolunteers(this.currentPage, this.pageSize);
      const data = response.data;
      if (Array.isArray(data)) {
        this.volunteers = data;
        this.totalCount = data.length;
      } else {
        this.volunteers = data.items;
        this.totalCount = data.totalCount;
      }
    },
    async onPageChange(page) {
      this.currentPage = page;
      this.loadVolunteers();
    },
    async handleAddVolunteer() {
      this.$router.push({
        path: "/volunteers/add",
      });
    },
    async handleDeleteVolunteer(id) {
      try {
        const { deleteVolunteer } = Volunteering;
        const response = await deleteVolunteer(id);
        const { data, status } = response;
        if (status == "200") {
          const index = this.volunteers.findIndex((prop) => prop.id === id);
          this.volunteers.splice(index, 1);
          notify.success(this, "Inregistrarea a fost stearsa.");
        } else {
          notify.error(this, "Eroare la stergerea inregistrarii.");
        }
      } catch (error) {
        notify.error(this);
      }
    },
  },
  computed: {
    titleStack() {
      return ["Registru Voluntariat", "Voluntari"];
    },
    heroRouterLinkTo() {
      return { name: "/volunteers/add" };
    },
  },
};
</script>
